import { PrimaryButton } from "../Primitives/Buttons";
import type { TMatter } from "../../models/matter-model";
import ConnectIcon from "../../../assets/svg/connect.svg";
import { ViewType } from "../Search/SearchPresentational";
import { MatterPresentational, Props as MatterPresentationalProps } from "../Matter/MatterPresentational";
import { TSmokeballTier } from "../../services/smokeball-authenticator";

export type Props = {
  tier: TSmokeballTier;
  isAssigning?: boolean;
  selectedMatter?: TMatter;
  assignedMatter?: TMatter;
  searchContent: React.ReactNode;
  attachmentsContent?: React.ReactNode;
  isCheckingForAssignedMatter: boolean;

  openAttachFiles?: (matterId: string) => void;
  openSelectFolder?: (matterId: string) => void;
  assignMatter?: (searchViewType: ViewType) => void;
  onMatterSelected: MatterPresentationalProps["onMatterSelected"];
};

const Spinner = (message?: string) => {
  return (
    <div className="flex flex-row items-center self-center m-2">
      <img src={ConnectIcon} className="w-8 h-8 animate-spin mr-1" alt="loading..." title="loading..." />
      <span>{message}</span>
    </div>
  );
};

export const TaskpanePresentational = (props: Props) => {
  if (props.isCheckingForAssignedMatter) {
    return Spinner("Reading email...");
  }

  return (
    <div className="flex flex-col h-full">
      <div className="flex flex-col flex-1 items-stretch max-h-full min-h-0 bg-neutral-50">
        <div className="flex flex-col justify-stretch bg-white min-h-0 max-h-full">
          {/* Search Content */}
          <div className="flex flex-col max-h-full min-h-0">{props.searchContent}</div>

          {/* Assigned Matter and Spinner */}
          {(props.assignedMatter || props.selectedMatter) && (
            <div className="flex flex-col flex-shrink-0 bg-white">
              <div className="flex flex-col min-h-0">
                <MatterPresentational
                  isSelected={true}
                  tier={props.tier}
                  matter={(props.assignedMatter || props.selectedMatter)!}
                  allowAction={true}
                  onMatterSelected={props.onMatterSelected}
                  searchViewType={"DEFAULT"}
                />
                {props.isAssigning && Spinner("Updating Smokeball")}
              </div>
            </div>
          )}
        </div>

        {/* Attachments Content */}
        <div className="flex flex-col min-h-0 flex-grow">{props.attachmentsContent}</div>

        {/* Save to Matter Button */}
        {props.selectedMatter && !props.assignedMatter && !props.isAssigning && (
          <div className="flex justify-end border-t border-neutral-150 p-2">
            <PrimaryButton
              title="Save To Matter"
              onClick={() => props.assignMatter && props.assignMatter("DEFAULT")}
              disabled={props.isAssigning}
            >
              Save to Matter
            </PrimaryButton>
            {props.isAssigning && <div className="absolute bottom-0 right-0">{Spinner("Updating Smokeball")}</div>}
          </div>
        )}

        {/* Attach Files Button */}
        {props.assignedMatter && props.openAttachFiles && (
          <div className="flex justify-end border-t border-neutral-150 p-2">
            <PrimaryButton
              onClick={() => props.assignedMatter && props.openAttachFiles!(props.assignedMatter.matterId)}
            >
              Attach Files
            </PrimaryButton>
          </div>
        )}
      </div>
    </div>
  );
};
